import { ENVIRONMENT_GLOBAL } from './global';

const VERSION = "1.4.3";

export const environment = {
  ...ENVIRONMENT_GLOBAL,
  version: VERSION,
  env: `Operational System ${VERSION}`,
  // Ip for send the ip hubio in the emails
  protocol: 'https://',
  hubioIp: 'op.doctorprox.com',
  gatewayIp: 'op.doctorprox.com',
  gatewayPort: '443',
  production: true,
  qa: false,
  defaultUrl: `https://op.doctorprox.com:443`,
  clientId: "swagger",
  clientSecret: "Th8E5LLop7say4HGXcLPCRJP12gEInPi"
};
